
import { mapState } from 'vuex'
export default {
  props: {
    list: {
      default: () => [],
      type: Array,
    },
    // https://github.com/vueComponent/ant-design-vue/blob/master/components/vc-slick/src/default-props.js#L3
    // 参数设置
    carouselProps: {
      default: () => {
        return {
          speed: 500,
          autoplaySpeed: 3000,
          autoplay: true,
          arrows: true,
          effect: 'fade'
        }
      },
      type: Object,
    },
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.isMobile,
    }),
    // 合并默认值与外部传入配置；仅在 PC 端注入拖拽相关 props，
    // 移动端保持原有 fade + 自定义 touchstart/touchend 逻辑不受影响
    mergedCarouselProps() {
      const defaults = {
        speed: 500,
        autoplaySpeed: 3000,
        autoplay: false, // 禁用内置 autoplay，使用自定义控制
        arrows: true,
        effect: 'fade',
      }
      const merged = { ...defaults, ...this.carouselProps, autoplay: false }
      if (!this.isMobile) {
        // PC 端：fade 模式下 slick 无滑动轨道，draggable 不生效，需切换为 scrollx
        merged.effect = 'scrollx'
        merged.draggable = true // 桌面端鼠标拖拽
        merged.swipeToSlide = true // 跟手滑动到最近的 slide
      }
      return merged
    },
  },
  data() {
    return {
      tempX: 0,
      tempY: 0,
      isHovering: false,
      firstSlideReady: false,
      autoplayTimer: null,
    }
  },
  mounted() {
    // 延迟触发第一张图的缩放动画
    this.$nextTick(() => {
      setTimeout(() => {
        this.firstSlideReady = true
      }, 100)
    })
    // 启动自定义自动播放
    this.startAutoplay()
  },
  beforeDestroy() {
    this.stopAutoplay()
  },
  methods: {
    // 启动自定义自动播放
    startAutoplay() {
      this.stopAutoplay()
      const speed = this.carouselProps?.autoplaySpeed || 3000
      this.autoplayTimer = setInterval(() => {
        if (!this.isHovering && this.$refs.carousel) {
          this.$refs.carousel.next()
        }
      }, speed)
    },
    // 停止自动播放
    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer)
        this.autoplayTimer = null
      }
    },
    // 鼠标离开：恢复自动播放
    handleMouseLeave() {
      this.isHovering = false
      // 确保自动播放继续
      this.startAutoplay()
    },
    // 移动端的click事件被屏蔽了，且冒泡被屏蔽了
    handleTouchStart(e) {
      this.tempX = 0
      this.tempY = 0
      const touch = e.changedTouches[0]
      this.tempX = touch.pageX
      this.tempY = touch.pageY
    },
    handleTouchEnd(e, item) {
      const touch = e.changedTouches[0]
      // 表示用户进行了点击，不是滑动
      if (
        this.tempX !== 0 &&
        this.tempX === touch.pageX &&
        this.tempY === touch.pageY
      ) {
        this.tempX = 0
        this.tempY = 0
        window.location.href = item.url
      }
    },
  },
}
